import { AdjustmentsHorizontalIcon, ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import Button from "src/components/Shared/Buttons/Button";
import { PlanCard } from "./PlanCard";
import Transactions from "./Transactions";
import PlanFeatures from "src/components/Site/Plans/List/PlanFeatures";

const ClientPlanDetails = ({ setShowPlanSelection, client, planDetails }) => {
  return (
    <div className="animate-fade-in">
      {planDetails ? (
        <div className="space-y-4">
          <div className="relative flex w-full flex-col gap-4">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <PlanCard
                  isUpcoming={planDetails?.upcoming_plan ? true : false}
                  prevPlan={planDetails?.upcoming_plan ? planDetails : null}
                  plan={planDetails?.upcoming_plan ? planDetails?.upcoming_plan : planDetails}
                  status={planDetails?.upcoming_plan ? "upcoming" : planDetails?.subscription_status}
                />
                <PlanFeatures features={(planDetails?.upcoming_plan ? planDetails?.upcoming_plan?.plan_details?.features : planDetails?.plan_details?.features) || []} />
              </div>
            </div>
          </div>

          <div className="flex justify-between rounded-md border border-b border-gray-200 p-3">
            <div className="flex items-center gap-3">
              <ClipboardDocumentCheckIcon className="h-6 w-6 text-gray-600" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Payment History</h3>
                <p className="text-sm text-gray-500">Review past transactions, also can modify the current plan for this client.</p>
              </div>
            </div>
            <Button
              version="secondary"
              onClick={() => setShowPlanSelection(true)}>
              <AdjustmentsHorizontalIcon className="h-5 w-5" />
              Change Plan
            </Button>
          </div>
          <Transactions clientId={client?._id} />
        </div>
      ) : (
        <div className="flex min-h-[200px] items-center justify-center rounded-xl border-2 border-dashed border-gray-300 bg-gradient-to-br from-gray-50 to-white">
          <div className="flex flex-col items-center justify-center p-4">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100">
              <ClipboardDocumentCheckIcon className="h-8 w-8 text-blue-600" />
            </div>
            <h3 className="mb-2 text-lg font-semibold text-gray-900">No Plan Assigned</h3>
            <p className="mb-4 text-gray-600">Get started by choosing a plan for this client</p>
            <Button
              version="secondary"
              onClick={() => setShowPlanSelection(true)}>
              <AdjustmentsHorizontalIcon className="h-5 w-5" />
              Choose Plan
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientPlanDetails;
